import { render, staticRenderFns } from "./PostCategoryDetail.vue?vue&type=template&id=2d5e1408"
import script from "./PostCategoryDetail.vue?vue&type=script&lang=js"
export * from "./PostCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports